export default __webpack_public_path__ + "static/media/MaisonNeueWEB-Medium.fe4e0a05.woff";